import React, { useState, useEffect } from "react";
import logo from "../../../assets/images/sbs/Logo-Say-What.png";
import captionImg from "../../../assets/images/sbs/caption-img.png";

import { Button } from "reactstrap";
import { useSelector } from "react-redux";
import _ from "lodash";

const ShowCase = ({ captionsArray, cc_countdown, onTimesUp, users }) => {
  const [numberOfCaptions, setNumberOfCaptions] = useState(0);

  const captionImage = useSelector(
    (state) => state.gameReducer?.roomObj?.game_state?.photo
  );

  useEffect(() => {
    let temp = 0;
    captionsArray &&
      captionsArray.length > 0 &&
      captionsArray.forEach((item) => {
        if (item.hasOwnProperty("caption")) {
          temp += 1;
        }
      });

    setNumberOfCaptions(temp);
  }, [captionsArray]);

  // const captionImage =
  return (
    <>
      <div className="caption-this-container">
        <div className="caption-this text-center">
          <img src={logo} className="say-what-logo" alt="logo" />
          <h2 className="text">Caption This!</h2>
          <img src={captionImage} className="caption-img" alt="caption" />
        </div>
        <div className="caption-bottom">
          <div className="time-div">
            <p className="time-txt">Time Remaining:</p>
            <p className="seconds">{cc_countdown} Seconds</p>

            {/* <p className="seconds">12 Seconds</p> */}
            {/* <p className="seconds">22 Seconds</p> */}
          </div>
          <Button onClick={() => onTimesUp()} className="done-btn">
            Everyone’s Done ({numberOfCaptions}/{users.length})
          </Button>
        </div>
      </div>
    </>
  );
};

export default ShowCase;
